import { render } from "./MobileSelectWord.component.vue?vue&type=template&id=7b184855"
import script from "./MobileSelectWord.component.vue?vue&type=script&lang=js"
export * from "./MobileSelectWord.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__